import { Add } from '@material-ui/icons';
import TablePagination from '@mui/material/TablePagination';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchCambiarSuccess,
  fetchCountPermisos,
  fetchPermisosAll,
  fetchTiposPermisos,
  fetchTiposPermisosCategorias,
  savePermiso,
  selectAllTiposPermisos,
  selectAllTiposPermisosCategorias,
  selectIsLoading,
  selectIsSuccess,
  selectMessage,
  selectPermisos,
  selectPermisosCount,
} from './../../../redux/Permisos/PermisosSlice';

import { fetchListDiasFeriadosAnoActual, selectDiasFeriadosAnoActual } from '../../../redux/DiasFeriados/DiasFeriadosSlice';

import swal from 'sweetalert';
import Permisos from '../../../Components/AccordionPermisos/Permisos';
import Firma from '../../../Components/Firma/Firma';
import Loading from '../../../Components/Modals/Loading/Loader';
import { selectUserData } from '../../../redux/Login/LoginSlice';
import { fetchEmpleadoFirmaExiste, selectEmpleadoFirmaExiste } from '../../../redux/Utility/UtilitySlice';
import PermisoNuevo from './../../../Components/Modals/Permiso/PermisoNuevo';

import PermisoEditar from '../../../Components/Modals/Permiso/PermisoEditar';
import { PermissionData } from '../../../context/Component/PermissionData';
import {
  fetchEmpleados,
  fetchGetHistorialLaboralSectorPublicoEmpleado,
  selectEmpleadoHistorialLaboralSectorPublico,
} from '../../../redux/Empleados/EmpleadosSlice';
import { calcularDiasHabiles } from '../../../utils/funcionesFechasPermisos';

const colors = {
  amarillo: '#FCFF23',
  gris: '#CFCFCF',
  verde: '#00C232',
  rojo: '#FF0C00',
};

export const DigitarPermiso = () => {
  // * FECHA ACTUAL
  const date = new Date();

  // * PERMISOS DEL USUARIO.
  const permisosState = PermissionData();

  // * FUNCIONES PARA RETORNAR FECHAS ASIGNADAS.
  const defaultHoraInicio = moment(new Date(date.getFullYear(), date.getMonth(), date.getDate(), 8, 0, 0, 0)).format('YYYY-MM-DD HH:mm:ss');

  const defaultHoraTermino = moment(new Date(date.getFullYear(), date.getMonth(), date.getDate(), 16, 0, 0, 0)).format('YYYY-MM-DD HH:mm:ss');

  // ? USE-FORM
  const form = useForm({
    defaultValues: {
      empleadoId: 0,
      tipoPermisoId: 0,
      dias: 0,
      fechaInicio: date,
      fechaTermino: date,
      horaInicio: defaultHoraInicio,
      horaTermino: defaultHoraTermino,
      recurrencia: {
        recurrente: false,
        l: false,
        m: false,
        x: false,
        j: false,
        v: false,
        s: false,
        d: false,
      },
      diaCompleto: false,
      justificacion: '',
    },
  });

  // * DESESTRUCTURACION DEL USE-FORM
  const { reset, setValue, watch, control } = form;

  // ? HOOK-WATCH
  const fechaInicio = useWatch({ control, name: 'fechaInicio' });

  const fechaTermino = useWatch({
    control,
    name: 'fechaTermino',
  });

  const tipoPermisoId = useWatch({
    control,
    name: 'tipoPermisoId',
  });

  const horaInicio = useWatch({
    control,
    name: 'horaInicio',
  });

  const horaTermino = useWatch({
    control,
    name: 'horaTermino',
  });

  // ? HOOK-WATCH CHECKED-RECURRENTE
  const checkedRecurrente = useWatch({
    control,
    name: 'recurrencia.recurrente',
  });

  // ? HOOK-DISPATCH
  const dispatch = useDispatch();

  // ? HOOK SELECTOR
  const usuario = useSelector(selectUserData);
  const isLoading = useSelector(selectIsLoading);
  const permisos = useSelector(selectPermisos);
  const permisosCount = useSelector(selectPermisosCount);
  const message = useSelector(selectMessage);
  const isSuccess = useSelector(selectIsSuccess);
  const validacionFirmaEmpleado = useSelector(selectEmpleadoFirmaExiste);
  const historialLaboralSectorPublicoEmpleado = useSelector(selectEmpleadoHistorialLaboralSectorPublico);
  const diasFeriados = useSelector(selectDiasFeriadosAnoActual);

  // ? HOOK-STATE PARA PAGINACION.
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [skipRow, setSkipRow] = useState(0);
  const [aprobacionesFilterState, setAprobacionesFilterState] = useState({});
  const [vacacionesInfoState, setVacacionesInfoState] = useState({
    cantidadAñosTrabajados: 0,
    cantidadDiasVacacionesPorAñoTrabajado: 0,
  });

  // ? HOOK-STATE PARA ABRIR EL MODAL DE FIRMA.
  const [openFirma, setOpenFirma] = useState(false);

  // ? HOOK-STATE PARA ENVIO DE DATA CON FIRMA
  const [dataFirma, setDataFirma] = useState({ file: '' });
  const [validateSendDataToApi, setValidateSendDataToApi] = useState(false);

  // ? HOOK-STATE
  const [expanded, setExpanded] = useState(false);
  const [openEdit, setOpenEdit] = useState({ open: false, permiso: {} });
  const [inputEmployeeDisabled, setInputEmployeeDisabled] = useState(false);
  const [tiposPermisosCategoriaGrupo, setTiposPermisosCategoriaGrupo] = useState([]);

  const tipospermisos = useSelector(selectAllTiposPermisos);
  const tipospermisosCategoria = useSelector(selectAllTiposPermisosCategorias);

  // * FUNCION PARA CARGAR PERMISOS
  const cargarPermisos = (aprobacionesFilter) => {
    dispatch(fetchPermisosAll({ aprobacionesFilter, skipRow, rowsPerPage }));
    dispatch(fetchCountPermisos(aprobacionesFilter));
    dispatch(fetchListDiasFeriadosAnoActual());
  };

  // * FUNCION PARA REFRESCAR LA VALIDACION DE LA FIRMA DEL EMPLEADO
  const refreshValidacionFirmaEmpleado = () => dispatch(fetchEmpleadoFirmaExiste({ empleadoId: usuario.Id }));

  // * FUNCIONES PARA PAGINACION
  // *
  const handleChangePage = (event, newPage) => {
    setSkipRow(newPage * rowsPerPage);
    setPage(newPage);
  };

  // *
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    setSkipRow(0);
  };

  // * FUNCION PARA REFRESCAR HISTORIAL LABORAL DE EMPLEADO.
  const refreshHistorialLaboralEmpleado = () =>
    dispatch(fetchGetHistorialLaboralSectorPublicoEmpleado({ empleadoId: usuario?.Id, fechaDesdePermiso: fechaInicio }));

  // ? HOOK-EFFECT PARA REFRESCAR LISTAS.
  useEffect(() => {
    refreshValidacionFirmaEmpleado();
    refreshHistorialLaboralEmpleado();
    dispatch(fetchTiposPermisos());
    dispatch(fetchTiposPermisosCategorias());
  }, []);

  // ? HOOK-EFFECT PARA MOSTRAR LOS MENSAJES Y RESETEAR LOS INPUTS.
  useEffect(() => {
    if (isSuccess === 'success' && message.length > 0) {
      cargarPermisos(aprobacionesFilterState);
      refreshValidacionFirmaEmpleado();
      swal('Exitoso!', message, 'success');
      dispatch(fetchCambiarSuccess());
      setOpen(false);
      setOpenFirma(false);
      setValidateSendDataToApi(false);
      reset();
    } else if (isSuccess === 'error' && message.length > 0) {
      swal('Error', message, 'error');
      dispatch(fetchCambiarSuccess());
    }
  }, [isSuccess]);

  // ? HOOK-EFFECT PARA FILTRACIONES.
  useEffect(() => {
    const aprobacionesFilter = {
      empleado: '',
      estadoPermiso: 0,
      estadoEmpleado: 1,
      areaOrganizacional: 0,
      empleadoId: 0,
    };

    // * ASIGNACION DE EMPLEADO-ID.
    aprobacionesFilter.empleadoId = usuario?.Id ?? 0;

    setAprobacionesFilterState(aprobacionesFilter);
    cargarPermisos(aprobacionesFilter);
  }, [usuario, skipRow, rowsPerPage]);

  // ? HOOK-EFFECT PARA ENVIAR DATA A API CUANDO SE REQUIERE UNA ACTUALIZACION O CREACION DE FIRMA
  useEffect(() => {
    if (validateSendDataToApi) {
      dispatch(savePermiso({ ...watch(), file: dataFirma.file }));
    }
  }, [validateSendDataToApi]);

  useEffect(() => {
    if (tipoPermisoId === 2) {
      refreshHistorialLaboralEmpleado();
    }
  }, [fechaInicio]);

  useEffect(() => {
    // * VALIDACION PARA REALIZAR EL CALCULO SI EL OBJETO NO ESTA VACIO Y EL TIPO-PERMISO-ID ES IGUAL A 2 (VACACIONES).
    if (Object.keys(historialLaboralSectorPublicoEmpleado).length > 0 && tipoPermisoId === 2) {
      // * DESESTRUCTURACION DE DATOS.
      const { cantidadAñosTrabajadosMEM, sumatoriaHistoriaLaboralSectorPublico } = historialLaboralSectorPublicoEmpleado;

      // * CANTIDAD DE AÑOS LABORADOS, PUEDE SER MODIFICADO SI LAS VACACIONES SOLICITADAS PUES LA FECHA DE INICIO
      // * ES MAYOR O IGUAL A LA DE INGRESO.
      const cantidadTotalAñosTrabajadosMod = cantidadAñosTrabajadosMEM + sumatoriaHistoriaLaboralSectorPublico;

      // * CONTADOR DE DIAS DE VACACIONES SEGUN LA CANTIDAD DE AÑOS TRABAJADOS EN EL SECTOR PUBLICO.
      let cantidadDiasVacaciones = 0;

      switch (true) {
        case cantidadTotalAñosTrabajadosMod < 5:
          cantidadDiasVacaciones = 15;
          break;

        case cantidadTotalAñosTrabajadosMod >= 5 && cantidadTotalAñosTrabajadosMod < 10:
          cantidadDiasVacaciones = 20;
          break;

        case cantidadTotalAñosTrabajadosMod >= 10 && cantidadTotalAñosTrabajadosMod < 15:
          cantidadDiasVacaciones = 25;
          break;

        case cantidadTotalAñosTrabajadosMod >= 15:
          cantidadDiasVacaciones = 30;
          break;

        default:
          break;
      }

      setVacacionesInfoState({
        cantidadAñosTrabajados: cantidadTotalAñosTrabajadosMod,
        cantidadDiasVacacionesPorAñoTrabajado: cantidadDiasVacaciones,
      });
    }
  }, [historialLaboralSectorPublicoEmpleado, fechaInicio, tipoPermisoId]);

  useEffect(() => {
    // * DESESTRUCTURACION DE DATOS.
    const { open, permiso } = openEdit;

    if (open) {
      setValue('empleadoId', permiso.empleadoId);
      setValue('id', permiso.id);
      setValue('tipoPermisoId', permiso.tipoPermisoId);
      setValue('justificacion', permiso.justificacion);
      setValue('horaInicio', permiso.horaInicio);
      setValue('horaTermino', permiso.horaTermino);
      setValue('fechaInicio', moment(permiso.fechaInicio, 'YYYY/MM/DD'));
      setValue('fechaTermino', moment(permiso.fechaTermino, 'YYYY/MM/DD'));
      setValue('diaCompleto', permiso.diaCompleto);
      setValue('recurrencia', permiso.recurrencia);
      setValue(
        'dias',
        Math.round(moment.duration(moment(permiso.fechaTermino, 'YYYY/MM/DD').diff(moment(permiso.fechaInicio, 'YYYY/MM/DD'))).asDays())
      );
    }
  }, [openEdit]);

  // ? HOOK-EFFECT PARA CALCULAR LOS DIAS DE DURACION DE PERMISO SEGUN LAS FECHAS.
  useEffect(() => {
    setValue('dias', calcularDiasHabiles({ fechaInicio, fechaTermino, diasFeriados, horaInicio, horaTermino, tipoPermisoId, setValue }));
  }, [fechaInicio, fechaTermino, tipoPermisoId, horaInicio, horaTermino]);

  // ? HOOK-EFFECT PARA RESTABLECER LOS CHECKBOX DE RECURRENCIA.
  useEffect(() => {
    if (!checkedRecurrente) {
      setValue('recurrencia.l', false);
      setValue('recurrencia.m', false);
      setValue('recurrencia.x', false);
      setValue('recurrencia.j', false);
      setValue('recurrencia.v', false);
      setValue('recurrencia.s', false);
      setValue('recurrencia.d', false);
    }
  }, [checkedRecurrente]);

  // ? HOOK-EFECT PARA SOLICITAR LOS DATOS A LA API.
  useEffect(() => {
    const dataSolicitar = {
      skipRow: 0,
      rowsPerPage: 0,
      areaOrganizacionalId: 0,
      empleado: '',
      estado: 1,
    };

    // * VALIDACION DEL TIPO DE RETORNO DE LOS ROLES DEL USUARIO, SI ES STRING SE AGREGA A UN ARRAY,
    // * DE LO CONTRARIO SIGNIFICA QUE EL USUARIO POSEE UN ARRAY DE STRING'S Y SE RETORNARA.
    const arrRoles = typeof usuario?.RoleID === 'string' ? ([usuario?.RoleID] ?? []) : (usuario?.RoleID ?? []);

    // * VALIDACION PARA DETERMINAR SI EL USUARIO POSEE EL ROL-ID 4 (CONTROL).
    const validacionRol = arrRoles?.some((value) => parseInt(value) === 4) ?? false;

    if (validacionRol) {
      dispatch(fetchEmpleados(dataSolicitar));
    }
    // * VALIDACION DE PERMISO EVALUADOR.
    else if (permisosState.ROLE_VER_PERMISO_SUB) {
      dispatch(
        fetchEmpleados({
          ...dataSolicitar,
          ['areaOrganizacionalId']: usuario?.AreaOrganizacionalId,
        })
      );
    } else {
      dispatch(fetchEmpleados(dataSolicitar));
      setInputEmployeeDisabled(true);
    }

    reset();
  }, [usuario, isSuccess]);

  // ? CREACION DE LISTA PARA ORDENAR LOS PERMISOS SEGUN LA CATEGORIA.
  useEffect(() => {
    const tiposPermisosCategoriaOrder = [];
    if (tipospermisosCategoria && tipospermisosCategoria.length > 0) {
      tipospermisosCategoria.forEach((element) => {
        const arrayTipoPermiso = tipospermisos.filter((x) => x.categoriaId === element.id);
        const categoria = {
          label: element.nombre,
          options: arrayTipoPermiso.map((x) => ({
            label: x.nombre,
            value: x.id,
          })),
        };
        tiposPermisosCategoriaOrder.push(categoria);
      });
      setTiposPermisosCategoriaGrupo(tiposPermisosCategoriaOrder);
    }
  }, [tipospermisosCategoria, tipospermisos]);

  // ? ASIGNACION DE USUARIO AL MOMENTO DE CREAR UN NUEVO PERMISO.
  useEffect(() => {
    if (open) {
      setValue('empleadoId', parseInt(usuario?.Id));
    }
  }, [open]);

  return (
    <div className="container-fluid main">
      <div className="row mt-2">
        <div className="col-md-12">
          <div>
            <h3 className="text-primary-mem">Permisos</h3>
            <hr />
          </div>
          <div className="col-md-12 bg-primary-mem text-center pb-1">
            <h3 className="text-white">Solicitudes Personalizadas</h3>
          </div>
          <div className="row mt-2  ">
            <div className="col-md-2 ">
              <div className="input-group">
                <button id="btn-nuevo-permiso" type="button" className="input-group-text btn-primary-mem" onClick={() => setOpen(true)}>
                  Nuevo Permiso <Add />
                </button>
              </div>
            </div>
            <div className="col-md-6  border pt-2 pb-1 d-flex  justify-content-center">
              <div className="row">
                <div className="col>">
                  <div className="input-group ">
                    <div
                      style={{
                        backgroundColor: colors.gris,
                        border: '1px solid gray',
                        borderRadius: 10,
                        marginRight: 5,
                        marginLeft: 5,
                        height: 20,
                        width: 20,
                      }}
                    />
                    <label>Pendiente</label>
                    <div
                      style={{
                        backgroundColor: colors.amarillo,
                        border: '1px solid gray',
                        borderRadius: 10,
                        marginRight: 5,
                        marginLeft: 5,
                        height: 20,
                        width: 20,
                      }}
                    />
                    <label>En espera</label>
                    <div
                      style={{
                        backgroundColor: colors.verde,
                        border: '1px solid gray',
                        borderRadius: 10,
                        marginRight: 5,
                        marginLeft: 5,
                        height: 20,
                        width: 20,
                      }}
                    />
                    <label>Aprobado</label>
                    <div
                      style={{
                        backgroundColor: colors.rojo,
                        border: '1px solid gray',
                        borderRadius: 10,
                        marginRight: 5,
                        marginLeft: 5,
                        height: 20,
                        width: 20,
                      }}
                    />
                    <label>Rechazado</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {permisos &&
            permisos.length > 0 &&
            permisos.map((permiso, index) => <Permisos key={index} permiso={permiso} setOpenEdit={setOpenEdit} buttonActive={false} />)}
          <TablePagination
            component="div"
            count={permisosCount}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />

          <Loading open={isLoading} />

          <FormProvider {...form}>
            <PermisoNuevo
              open={open}
              setOpen={setOpen}
              setOpenFirma={setOpenFirma}
              openFirma={openFirma}
              validacionFirmaEmpleado={validacionFirmaEmpleado}
              vacacionesInfoState={vacacionesInfoState}
              inputEmployeeDisabled={inputEmployeeDisabled}
              tiposPermisosCategoriaGrupo={tiposPermisosCategoriaGrupo}
            />

            <PermisoEditar
              setExpanded={setExpanded}
              setOpenEdit={setOpenEdit}
              openEdit={openEdit}
              tiposPermisosCategoriaGrupo={tiposPermisosCategoriaGrupo}
            />
          </FormProvider>

          <Firma
            setOpen={setOpenFirma}
            open={openFirma}
            form={form}
            setDataFirma={setDataFirma}
            setValidateSendDataToApi={setValidateSendDataToApi}
          />
        </div>
      </div>
    </div>
  );
};

export default DigitarPermiso;
